<template>
  <v-dialog @update:returnValue="setEditItemIdZero" v-model="dialogResult" max-width="500px" persistent>
    <v-card>
      <v-card-text>

        <slot name="CaseAndAmount"
          :casesList="casesList"
          :selectedCase="selectedCase"
          :amount="amount"
        ></slot>

        <slot name="ItemsSelection"
          :selectedItemType="selectedItemType"
          :inventoriesList="inventoriesList"
          :servicesList="servicesList"
          :caseManagersList="caseManagersList"
          :selectedInventory="selectedInventory"
          :selectedService="selectedService"
          :selectedCaseManager="selectedCaseManager"
        ></slot>

        <v-flex md12>
          <v-select
            :items="selectedList"
            v-model="selectedEntity"
            label="Select items"
          >
            <template slot="item" slot-scope="props">
              {{ props.item.name }} - {{ props.item.description }}
            </template>
            <template slot="selection" slot-scope="props">
              {{ props.item.name }} - {{ props.item.description }}
            </template>
          </v-select>
        </v-flex>

        <v-flex md12>
          <v-menu
            v-model="menuDateStart"
          >
            <v-text-field
              v-model="date.dateStart"
              slot="activator"
              label="Select start date"
              prepend-icon="event"
              readonly
            ></v-text-field>
            <v-date-picker v-model="date.dateStart" reactive></v-date-picker>
          </v-menu>
        </v-flex>

        <v-flex md12>
          <v-menu
            :close-on-content-click="false"
            v-model="menuTimeStart"
          >
            <v-text-field
              v-model="date.timeStart"
              slot="activator"
              label="Select start time"
              prepend-icon="alarm"
              readonly
            ></v-text-field>
            <v-time-picker v-model="date.timeStart"></v-time-picker>
          </v-menu>
        </v-flex>

        <v-flex md12>
          <v-menu
            v-model="menuDateEnd"
          >
            <v-text-field
              v-model="date.dateEnd"
              slot="activator"
              label="Select end date"
              prepend-icon="event"
              readonly
            ></v-text-field>
            <v-date-picker v-model="date.dateEnd" reactive></v-date-picker>
          </v-menu>
        </v-flex>

        <v-flex md12>
          <v-menu
            :close-on-content-click="false"
            v-model="menuTimeEnd"
          >
            <v-text-field
              v-model="date.timeEnd"
              slot="activator"
              label="Select end time"
              prepend-icon="alarm"
              readonly
            ></v-text-field>
            <v-time-picker v-model="date.timeEnd" ></v-time-picker>
          </v-menu>
        </v-flex>

      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" flat @click.stop="editItemDataDecorator">Save</v-btn>
        <v-btn color="primary" flat @click.stop="dialogClose">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import dialogMixins from '@/mixins/EditResourceDialog'
  import bookingsMixins from '@/mixins/Bookings'
  import consts from '@/config/consts'

  export default {
    mixins: [ dialogMixins, bookingsMixins ],
    data () {
      return {
        resource: 'schedules',
        casesList: [],
        inventoriesList: [],
        servicesList: [],
        caseManagersList: [],
        selectedInventory: { id: 0 },
        selectedService: { id: 0 },
        selectedCaseManager: { id: 0 },
        selectedItemType: { id: consts.schedules.SERVICE_TYPE_ID },
        // selectedItemType: { id: 0 },
        selectedCase: { id: 0 },
        menuDateStart: false,
        menuDateEnd: false,
        menuTimeStart: false,
        menuTimeEnd: false,
        amount: {
          number: 0
        }
      }
    },
    computed: {
      date () {
        let dateStart = null
        let dateEnd = null
        let timeStart = null
        let timeEnd = null

        if (this.itemData.schedule_start) {
          dateStart = this.itemData.schedule_start.split(' ')

          timeStart = dateStart[1]
          dateStart = dateStart[0]
        }

        if (this.itemData.schedule_end) {
          dateEnd = this.itemData.schedule_end.split(' ')

          timeEnd = dateEnd[1]
          dateEnd = dateEnd[0]
        }

        let obj = {
          dateStart: dateStart,
          dateEnd: dateEnd,
          timeStart: timeStart,
          timeEnd: timeEnd
        }

        return obj
      },
      entityListName () {
        return this.itemTypeIDInDBToEntitiesListNameMap[this.itemData.item_type]
      },
      entityNameSelected () {
        return this.entitiesListNameToSelectedEntityNameMap[this.entityListName]
      },
      selectedList () {
        return this.listsMap[this.entityListName]
      },
      selectedEntity: {
        get () {
          if (this.entitiesSelectedMap[this.entityNameSelected]) {
            return this.entitiesSelectedMap[this.entityNameSelected].id
          }

          return 0
        },
        set (newVal) {
          this.entitiesSelectedMap[this.entityNameSelected].id = newVal
        }
      }
    },
    watch: {
      itemId (newVal, oldVal) {
        if (newVal > 0) {
          this.itemData = {}
          this.selectedCase.id = null
          this.selectedInventory.id = 0
          this.selectedService.id = 0
          this.selectedCaseManager.id = 0

          this.loadItemData(newVal).then(result => {
            this.selectedItemType.id = this.itemData.item_type

            this.amount.number = this.itemData.amount

            this.selectedList.forEach((item, i) => {
              if (item.id === this.itemData.item_id) {
                this.selectedEntity = this.itemData.item_id
              }
            })

            this.casesList.forEach((item, i) => {
              if (item.id === this.itemData.cases_id) {
                this.selectedCase.id = this.itemData.cases_id
              }
            })
          })

          this.dialogResult = true
        }
      },
      selectedItemType: {
        handler (newVal) {
          this.itemData.item_type = newVal.id
        },
        deep: true
      }
    },
    methods: {
      editItemDataDecorator () {
        let scheduleStart = this.date.dateStart + ' ' + this.date.timeStart
        let scheduleEnd = this.date.dateEnd + ' ' + this.date.timeEnd

        this.itemData.schedule_start = scheduleStart
        this.itemData.schedule_end = scheduleEnd

        this.itemData.amount = this.amount.number

        this.itemData.cases_id = this.selectedCase.id
        this.itemData.item_id = this.itemTypeToItemIDMap[this.selectedItemType.id].id

        this.editItemData()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AppEditBookingsBaseDialog.vue?24ef47e4